import firebase from 'firebase/app';
import 'firebase/database';
import Rebase from 're-base';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyBekt9sGf6rTcgpNn7Zgz-8jRqA4ArDMsY",
    authDomain: "chatarang2018.firebaseapp.com",
    databaseURL: "https://chatarang2018.firebaseio.com",
    projectId: "chatarang2018",
    storageBucket: "",
    messagingSenderId: "184822390032"
  };

  const app = firebase.initializeApp(config);

  //Configure database
  const db = firebase.database(app);
  const base = Rebase.createClass(db);

  //Configure authentication
  export const auth = firebase.auth();
  export const googleProvider = new firebase.auth.GoogleAuthProvider();
  export const githubProvider = new firebase.auth.GithubAuthProvider();
  
  export default base;


// WEBPACK FOOTER //
// ./src/base.js